<template>
    <div class="container-my-debits">
        <template>
            <div class="header-debits">
                <i @click="$router.push({name: 'AccordionTabs'})"
                   :style="{color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'}"
                   class="fas fa-times"/>
            </div>
            <h3 :style="{color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)'}">Minhas Dívidas</h3>
            <p v-if="dividas && dividas.length > 0" class="message-sub">Você possui {{dividas.length}} {{dividas.length === 1 ? 'dívida' : 'dívidas'}} pendentes</p>
            <p v-else class="message-sub">Você não possui nenhuma dívida</p>
            <DebitCard v-for="divida in dividas" :key="divida.pes_codigo" :divida="divida"/>
        </template>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import DebitCard from "./components/DebitCard";
    import Template from "../../admin/Template";
    import Vue from "vue";
    export default {
        name: "MyDebits",
        props:[
            'divida'
        ],
        components: {Template, DebitCard},
        async created(){
            this.action_getValoresFuturos({
              cpfCnpj: this.cpfCnpj,
            }).then(response => {
              this.SET_LANCAMENTOS_FUTUROS(response.data.dados.futuros);
              this.dividas.forEach((divida, index) => {
                if(divida.loj_codigo == 16){
                 let encontrou = this.lançamentosfuturos.find(lançamentoFuturo => lançamentoFuturo.con_contrato === divida.con_contrato)
                  if (encontrou != undefined){
                    this.dividas[index] = {...this.dividas[index], ...encontrou, ...{"possuiLancamentosFuturos" : true}}
                  }
                  this.$forceUpdate();
                }
              })
            }).catch(error => {
              return error;
            })
        },
        async mounted() {
            this.SET_LOADING(true);
            this.SET_LOADING_MESSAGE('Carregando suas dívidas.');
            if(this.empresas && this.empresas.length > 0){
               let dividas = [];
                let newPromise;
                let promises = [];
                this.empresas.forEach((empresa) => {
                    promises.push(
                        this.action_getValores({
                            pes_codigo: empresa.pes_codigo,
                            loj_codigo: empresa.loj_codigo,
                            desconto_principal: "100",
                            desconto_juros: "100",
                            desconto_multa: "100",
                            desconto_corrigido: "100",
                            flg_agrupar_contratos: this.parceiroConfig?.sessoes?.customization?.campos?.myDebits?.flgAgruparContratos ? this.parceiroConfig?.sessoes?.customization?.campos?.myDebits?.flgAgruparContratos : false,
                            emp_codigo: empresa.emp_codigo,
                            pagamento_avista_prazo: "A"
                        }).then(response => {
                            if(response.data.retorno && response.data.mensagem?.fases_de_desconto){
                              let contrato = [];
                              newPromise = new Promise((resolve, reject) => {
                                response.data.mensagem?.fases_de_desconto.forEach((fase, indexFase) => {
                                    this.action_getValores({
                                      pes_codigo: empresa.pes_codigo,
                                      loj_codigo: empresa.loj_codigo,
                                      desconto_principal: "100",
                                      desconto_juros: "100",
                                      desconto_multa: "100",
                                      desconto_corrigido: "100",
                                      emp_codigo: empresa.emp_codigo,
                                      pagamento_avista_prazo: "P",
                                      fases_desconto: fase.fases_desconto
                                    }).then(response => {
                                      if(response.data.retorno && response.data.mensagem?.contratos){
                                        response.data.mensagem?.contratos.forEach((umContrato) => {
                                          if (indexFase !== 0){
                                            contrato[0].parcelaFases.push(umContrato.fases)
                                          } else{
                                            resolve()
                                            umContrato.parcelaFases = new Array()
                                            umContrato.parcelaFases.push(umContrato.fases)
                                            contrato.push({
                                              ...umContrato,
                                            })
                                          }
                                        });
                                      }
                                    }).catch(error => {
                                      return error;
                                    })
                                });
                              })
                              newPromise.then(() => {
                                dividas.push({
                                  ...empresa,
                                  ...contrato[0],
                                })
                              })
                            } else if(response.data.retorno && response.data.mensagem?.contratos) {
                                response.data.mensagem?.contratos.forEach((contrato) => {
                                  dividas.push({
                                    ...empresa,
                                    ...contrato,
                                  })
                                });
                            }
                            return response;
                        }).catch(error => {
                            return error;
                        })
                    );
                });
                await Promise.all(promises);

                this.SET_DIVIDAS(dividas);
                this.SET_LOADING_MESSAGE('');
                this.SET_LOADING(false);
            }
        },
        methods:{
          ...mapActions(['action_getValores', 'action_getValoresFuturos']),
          ...mapMutations(['SET_DIVIDAS','SET_LOADING', 'SET_LANCAMENTOS_FUTUROS', "SET_LOADING_MESSAGE"]),
          getSubdominio(){
               return window.location.host.split('.').length > 2;
          }
        },
        computed:{
            ...mapState({
                empresas: state => state.empresas,
                dividas: state => state.dividas,
                lançamentosfuturos: state => state.lançamentosfuturos,
                parceiro: state => state.parceiro,
                parceiroConfig: state => state.parceiroConfig,
                cpfCnpj: state => state.cpfCnpj
            })
        }
    }
</script>

<style scoped>
    .container-my-debits{
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #F3F5F9;
        flex: 1;
        box-sizing: border-box;
    }

    .header-debits{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        max-width: 750px;
        cursor: pointer;
    }

    h3{
        color: #031B4E;
        font-family: Montserrat-Bold;
        font-size: 28px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    .header-debits i{
        font-size: 48px;
        color: #031B4E;
    }

    .message-sub{
        color: #5b6987;
        font-size: 14px;
        margin-bottom: 10px;
    }
</style>
